var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tinymce-editor',{attrs:{"id":_vm.id,"placeholder":_vm.placeholder,"required":_vm.required,"init":_vm.tinymceInit,"disabled":_vm.disabled,"api-key":"czipsfyatybrq1wjfpqtqnm2yq6m56thln0j2wqca3fffg2f"},model:{value:(_vm.valData),callback:function ($$v) {_vm.valData=$$v},expression:"valData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }